import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';

function Navgation() {
  return (
    <Navbar collapseOnSelect expand="lg" className="bg-body-tertiary">
      <Container>
        <img src='arh logo2.jpg' alt='' style={{width:'200px'}}></img>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="ms-auto">
            <Nav.Link href="/" style={{color:'black'}}>HOME</Nav.Link>
            <Nav.Link href="/" style={{color:'black'}}>SERVICE</Nav.Link>
            <Nav.Link href="/" style={{color:'black'}}>CAREERS</Nav.Link>
            <Nav.Link href="Contact" style={{color:'black'}}>CONTACT US</Nav.Link>
          </Nav>
         
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default Navgation;